import { AirportShuttle, Announcement, CandlestickChart, EventAvailable, School, Timelapse } from '@mui/icons-material';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const SchoolBoardPage = lazy(() => import('pages/SchoolBoardPage'));
const SchoolClassPage = lazy(() => import('pages/SchoolClass/_components/SchoolClassPage'));
const SchoolShiftList = lazy(() => import('pages/SchoolShiftPage/_components/SchoolShiftList'));
const SchoolTicketPage = lazy(() => import('pages/SchoolTicketPage'));
const SchoolTransportationPage = lazy(() => import('pages/SchoolTransportation'));
const TemporaryReleaseEventPage = lazy(() => import('pages/TemporaryReleaseEventPage'));

export const schoolRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'Gestão Escolar',
		key: 'school-management',
		icon: <School />,
		protected: true,
		collapse: [
			{
				type: 'collapse',
				name: 'routersNames.trans',
				key: 'trans',
				icon: <AirportShuttle />,
				route: `${DEFAULT_ROUTE}/trans`,
				permissionId: [Permissions.ALL],
				component: <SchoolTransportationPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Turma',
				key: 'class',
				icon: <School />,
				route: `${DEFAULT_ROUTE}/class`,
				permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
				component: <SchoolClassPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Turno',
				key: 'turn',
				icon: <Timelapse />,
				route: `${DEFAULT_ROUTE}/turn`,
				permissionId: { any: [Permissions.STUDENT, Permissions.RESPONSIBLE] },
				component: <SchoolShiftList />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Ticket Escolar',
				key: 'ticket',
				icon: <CandlestickChart />,
				route: `${DEFAULT_ROUTE}/ticket`,
				permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
				component: <SchoolTicketPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Mensageria',
				key: 'school-board-menu-item',
				icon: <Announcement />,
				route: `${DEFAULT_ROUTE}/schoolboard`,
				component: <SchoolBoardPage />,
				permissionId: [Permissions.SCHOOL_BOARD],
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Liberações Temporárias',
				key: 'temporary-release-events',
				icon: <EventAvailable />,
				route: `${DEFAULT_ROUTE}/temporary-release-events`,
				component: <TemporaryReleaseEventPage />,
				protected: true,
			},
		],
	},
];
